import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataService } from '../../../data.service';
import { tap } from 'rxjs/operators';
import { PasswordValidator } from '../../../_helpers/password.validator';
import { matchOtherValidator } from '../../../_helpers/matchOther.validator';
import { FormService } from 'src/app/form.service';

@Component({
  selector: 'app-change-password-form',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  @Output() successChange = new EventEmitter();
  @Output() errorChange = new EventEmitter();

  show = {};

  form = new FormGroup({

    currentPassword: new FormControl(null, [Validators.required]),

    newPassword: new FormControl(null, [
      Validators.required,
      Validators.minLength(8),
      PasswordValidator.number,
      PasswordValidator.upper,
      PasswordValidator.lower,
      PasswordValidator.special
    ]),
    repeatPassword: new FormControl(null, [Validators.required, matchOtherValidator('newPassword')]),

  });

  constructor(
    private dataService: DataService,
    private formService: FormService
  ) { }

  ngOnInit() {
  }

  onSubmit() {
    this.formService.markAsTouched(this.form.controls);
    if (this.form.valid) {
      this.dataService.invoke(`/salonexpert-business/client/change-password`, 'post', null, this.form.value)
      .subscribe(
        res => {
          this.successChange.emit(true);
        },
        err => {
          this.errorChange.emit(err);
        }
      );
    }
  }
}
